var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 15,
    viewBox: "0 0 29 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.75098,
    y: 0.75,
    width: 19.5,
    height: 13.5,
    rx: 2.25,
    fill: "white",
    stroke: "#5A52C3",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4057 8.59478C14.9804 8.89229 14.4155 8.89601 13.9863 8.60412L5.79536 3.03368C4.77761 2.34153 5.2675 0.75006 6.49831 0.750061L22.6526 0.750062C23.8749 0.750062 24.3707 2.3237 23.3691 3.02434L15.4057 8.59478Z",
    fill: "white",
    stroke: "#5A52C3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.aa3758d8340399bfae2953ea9aaccafe.svg";
export { ForwardRef as ReactComponent };